import { render } from "./BaseImageLogo.vue?vue&type=template&id=0ec660af&scoped=true&ts=true"
import script from "./BaseImageLogo.vue?vue&type=script&lang=ts"
export * from "./BaseImageLogo.vue?vue&type=script&lang=ts"

import "./BaseImageLogo.vue?vue&type=style&index=0&id=0ec660af&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec660af"]])

export default __exports__